import firebase from "firebase/app";
import "firebase/firestore";
import { db } from "../../../firebase/firebase.utils";
export {
  blockUser,
  unblockUser,
  setConnectionMuted,
} from "../../../firebase/chatPreferences";
export const PAGE_SIZE = 12;
export const connectionIdFor = (a, b) =>
  a && b ? [String(a), String(b)].sort().join("_") : null;
export const requestIdFor = (fromUid, toUid) =>
  fromUid && toUid ? `${fromUid}_${toUid}` : null;
export const firstProfilePhoto = (imageUrl) =>
  Array.isArray(imageUrl) ? imageUrl.find(Boolean) || null : imageUrl || null;
export const fetchUsersByIds = async (ids = []) => {
  const unique = [...new Set(ids.filter(Boolean).map(String))];
  const snapshots = await Promise.all(
    unique.map((uid) => db.collection("users").doc(uid).get()),
  );
  return snapshots
    .filter((s) => s.exists)
    .map((s) => ({ ...s.data(), uid: s.id, id: s.id }));
};
const authorKey = (uid) =>
  String(uid || "")
    .trim()
    .toLowerCase()
    .replace(/\./g, "_");
let lastAuthorPruneAt = 0;
export const pruneAuthorScores = async (uid, limit = 60) => {
  const now = Date.now();
  if (now - lastAuthorPruneAt < 25_000) return;
  lastAuthorPruneAt = now;
  const ref = db.collection("users").doc(String(uid));
  const snapshot = await ref.get();
  if (!snapshot.exists) return;
  const entries = Object.entries(
    snapshot.data()?.postSignals?.authorScore || {},
  );
  if (entries.length <= limit) return;
  entries.sort((a, b) => Number(b[1] || 0) - Number(a[1] || 0));
  const updates = {};
  entries.slice(limit).forEach(([key]) => {
    updates[`postSignals.authorScore.${key}`] =
      firebase.firestore.FieldValue.delete();
  });
  updates.updatedAt = firebase.firestore.FieldValue.serverTimestamp();
  await ref.update(updates);
};
export const toggleFollow = async ({ uid, profileUid, following }) => {
  const ref = db.collection("follows").doc(`${uid}_${profileUid}`);
  if (following) {
    await ref.delete();
    return;
  }
  const batch = db.batch();
  batch.set(
    ref,
    {
      followerId: String(uid),
      followingId: String(profileUid),
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    },
    { merge: true },
  );
  batch.update(db.collection("users").doc(String(uid)), {
    [`postSignals.authorScore.${authorKey(profileUid)}`]:
      firebase.firestore.FieldValue.increment(3),
    updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
  });
  await batch.commit();
};
export const sendConnectionRequest = (fromUid, toUid) =>
  db
    .collection("connectionRequests")
    .doc(requestIdFor(fromUid, toUid))
    .set(
      {
        fromUid: String(fromUid),
        toUid: String(toUid),
        status: "pending",
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      },
      { merge: true },
    );
export const acceptConnectionRequest = async (fromUid, toUid) => {
  const batch = db.batch();
  batch.update(
    db.collection("connectionRequests").doc(requestIdFor(fromUid, toUid)),
    {
      status: "accepted",
      respondedAt: firebase.firestore.FieldValue.serverTimestamp(),
    },
  );
  batch.set(
    db.collection("connections").doc(connectionIdFor(fromUid, toUid)),
    {
      uids: [String(fromUid), String(toUid)].sort(),
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
    },
    { merge: true },
  );
  await batch.commit();
};
export const declineConnectionRequest = (fromUid, toUid) =>
  db
    .collection("connectionRequests")
    .doc(requestIdFor(fromUid, toUid))
    .update({
      status: "declined",
      respondedAt: firebase.firestore.FieldValue.serverTimestamp(),
    });
export const removeConnection = (uid, profileUid) =>
  db.collection("connections").doc(connectionIdFor(uid, profileUid)).delete();
